import { create } from 'zustand';

export interface FieldRegistration {
  fieldId: string;
  label: string;
  isCustom: boolean;
  defaultRequired: boolean;
  forcedRequired: boolean;
}

interface FormFieldRegistryState {
  registeredFields: Map<string, FieldRegistration>;
  registerField: (fieldId: string, registration: FieldRegistration) => void;
  unregisterField: (fieldId: string) => void;
  getField: (fieldId: string) => FieldRegistration | undefined;
  getAllFields: () => FieldRegistration[];
  clear: () => void;
}

export const useFormFieldRegistryStore = create<FormFieldRegistryState>(
  (set, get) => ({
    registeredFields: new Map(),

    registerField: (fieldId, registration) =>
      set((state) => {
        const next = new Map(state.registeredFields);
        next.set(fieldId, registration);

        return { registeredFields: next };
      }),

    unregisterField: (fieldId) =>
      set((state) => {
        const next = new Map(state.registeredFields);
        next.delete(fieldId);

        return { registeredFields: next };
      }),

    getField: (fieldId) => get().registeredFields.get(fieldId),

    getAllFields: () => Array.from(get().registeredFields.values()),

    clear: () => set({ registeredFields: new Map() }),
  })
);
